import { Box, Heading } from '@primer/react';
import FormsLayout from '~/src/layouts/forms-layout';
import * as React from 'react';
export default {
  Box,
  Heading,
  FormsLayout,
  React
};